export const apiURL = "https://server.akashpatel3338.now.sh/api/";
export const serverDomain = "https://server.akashpatel3338.now.sh/";
export const authURL = "https://server.akashpatel3338.now.sh/auth/";
export const regExp = {
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: /^\d{10}$/
};
export const getToken = () => localStorage.getItem("token") || "";
